import { Tab as MUITab, TabProps } from '@mui/material';

export const Tab = ({ ...props }: TabProps) => <MUITab {...props} />;
